import { createContext, useEffect, useState, useMemo, useContext, useRef} from 'react';
import {BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import { useLocation, useNavigate, useSearchParams} from 'react-router-dom';

import AppContext from '../hooks/AppContext'
import RouteContext from '../hooks/RouteContext'

import {validaCodigoLocalidade, validaCodigoEleicao, 
        validaCodigoCargo, validaCodigoZe, 
        validaCodigolocalVotacao} from '../utils/utils'

const SearchParamContext = createContext();

export const SearchParamContextProvider  = ({children}) => {

    const {eleicoes, localidades, ufs, cargos, zonasEleitorais, locaisVotacao, rolagemAuto, setRolagemAuto,       
        localidadeSelecionadaId, setLocalidadeSelecionadaId, 
        cargoSelecionadoId, setCargoSelecionadoId, 
        zonaESelecionadaId, setZonaESelecionadaId,
        localVSelecionadoId, setLocalVSelecionadoId } = useContext(AppContext);
    const {routeName, rotaVotacao, rotaSecoes, rotaAcompanhamento, rotaPendencias, rotaLogin, rotaError} = useContext(RouteContext);

    //Search Params Names
    const eleParamName = "e"
    const localParamName = "l"
    const cargoParamName = "c"
    const zeParamName = "z"
    const localVotaParamName = "v"
    //const rolagemAutoName = "ra"

    //Search Params
    const [searchParams, setSearchParams] = useSearchParams();

    const paramEle = useMemo(()=> searchParams.get(eleParamName), [searchParams]);
    const paramLocal = useMemo(()=> searchParams.get(localParamName), [searchParams]);
    const paramCargo = useMemo(()=> searchParams.get(cargoParamName), [searchParams]);
    const paramZe = useMemo(()=> searchParams.get(zeParamName), [searchParams]);
    const paramLovalVota = useMemo(()=> searchParams.get(localVotaParamName), [searchParams]);
    //const paramRolagemAuto = useMemo(()=> searchParams.get(rolagemAutoName), [searchParams]);
  
    const eleicaoTemLocalidade= (ufs,eleicao,codLocalidade) =>{        
        return eleicao?.localidades?.some(
            local => (local === codLocalidade) || (eleicao?.tipoAbrangencia!=="Municipal" && ufs?.some(uf => uf?.sgUe==codLocalidade))
        );
    }

    //verifica se uma eleição tem a localidade
    const eleicoesTemLocalidadeCargo= (ufs,codLocalidade, codCargo,) =>{
        return eleicoes.some( ele => {            
            return ( eleicaoTemLocalidade(ufs,ele,codLocalidade) && ele?.cargos?.includes(codCargo) )
        })  
    }

    //processa os search params após a carga de dados básicos e seta as configurações selecionadas
    useEffect(() => {
        
        let paramsObj = searchParams        

        if(!rotaVotacao && !rotaSecoes){            
            paramsObj.delete(eleParamName)
            paramsObj.delete(localParamName)
            paramsObj.delete(cargoParamName)
            paramsObj.delete(zeParamName)
            paramsObj.delete(localVotaParamName)             
            
        }else{
            //Seleciona Localidade pelo parametro  
            if(localidades?.length>0){
                if(paramLocal && localidadeSelecionadaId!==undefined){
                   
                    //valida localidade para o cargo que se deseja exibir filtrando acesso de cargos municipais para o estado inteiro
                    let localValidado = validaCodigoLocalidade(localidades,ufs,paramLocal)
                    if(paramCargo){
                        let cargoValidado = validaCodigoCargo(cargos, Number(paramCargo))
                        if(eleicoesTemLocalidadeCargo(ufs, localValidado, cargoValidado)){
                            setLocalidadeSelecionadaId(validaCodigoLocalidade(localidades,ufs,paramLocal));                               
                        }else{
                            paramsObj.delete(localParamName)                            
                        }                        
                    }else{
                        setLocalidadeSelecionadaId(validaCodigoLocalidade(localidades,ufs,paramLocal));      
                    }                                                            
                    
                }else{
                    if(localidadeSelecionadaId){
                        paramsObj.set(localParamName,localidadeSelecionadaId)  
                    }                
                }
            }   
        }

        if(rotaVotacao){                      
            //Seleciona cargo pelo parametro caso esteja na rota de candidatos      
            if(cargos?.length>0){
                if(paramCargo && cargoSelecionadoId!==undefined){        
                    setCargoSelecionadoId(validaCodigoCargo(cargos, Number(paramCargo)));
                }else{
                    if(cargoSelecionadoId){
                        paramsObj.set(cargoParamName,cargoSelecionadoId)  
                    }
                }
            }
            //remove parametros não utilizados nesta rota
            paramsObj.delete(zeParamName)
            paramsObj.delete(localVotaParamName)
        }

        if(rotaSecoes){
            //Seleciona zona eleitoral pelo parametro caso esteja na rota de secoes
            if(zonasEleitorais?.length>0){
                if(paramZe && zonaESelecionadaId!==undefined){            
                    setZonaESelecionadaId(validaCodigoZe(zonasEleitorais, Number(paramZe)));            
                }else{
                    if(zonaESelecionadaId){
                        paramsObj.set(zeParamName,zonaESelecionadaId)  
                    }
                }
                //Seleciona local de votação pelo parametro caso esteja na rota de secoes              
                //somente para quando a zona também está selecionada
                if(locaisVotacao?.length>0){
                    if(paramLovalVota && localVSelecionadoId!==undefined){
                        setLocalVSelecionadoId(validaCodigolocalVotacao(locaisVotacao,paramLovalVota));
                    }else{
                        if(localVSelecionadoId){
                            paramsObj.set(localVotaParamName,localVSelecionadoId)  
                        }
                    }
                }                
            }    
            //remove parametros não utilizados nesta rota
            paramsObj.delete(eleParamName)
            paramsObj.delete(cargoParamName)        
        }

        setSearchParams(paramsObj?.toString()) 

    },[ localidades, ufs, cargos, zonasEleitorais, locaisVotacao, rotaVotacao, rotaSecoes])

    //processa a mudança de filtros de seleção e altera o searchparam referente
    useEffect(() => {       
        processSerchParam();
    },[localidadeSelecionadaId, cargoSelecionadoId, zonaESelecionadaId, localVSelecionadoId, rolagemAuto]);

    const processSerchParam = () =>{
          
        //gera os parametros de url com base nos filtros de pesquisa e nos parametros anteriores
        let paramsObj = searchParams

        //param localidade
        if(localidadeSelecionadaId){                    
            paramsObj.set(localParamName,localidadeSelecionadaId)
        }else{
            if(localidadeSelecionadaId===undefined){
                paramsObj.delete(localParamName)
            }
        }
        //param cargo
        if(cargoSelecionadoId){                    
            paramsObj.set(cargoParamName,cargoSelecionadoId)
        }else{
            if(cargoSelecionadoId===undefined){
                paramsObj.delete(cargoParamName)
            }
        }
        //param zona eleitoral
        if(zonaESelecionadaId){                    
            paramsObj.set(zeParamName,zonaESelecionadaId)

            //somente inclui o local de votação se ouver a seleção de ze
            if(localVSelecionadoId){                    
                paramsObj.set(localVotaParamName,localVSelecionadoId)
            }else{
                if(localVSelecionadoId===undefined){
                    paramsObj.delete(localVotaParamName)
                }
            }

        }else{
            if(zonaESelecionadaId===undefined){
                paramsObj.delete(zeParamName)
            }
            if(localVSelecionadoId===undefined){
                paramsObj.delete(localVotaParamName)
            }
        }      
        
        setSearchParams(paramsObj?.toString())       
    }

    return(
        <SearchParamContext.Provider value={{paramEle, paramLocal, paramCargo, paramZe, paramLovalVota, searchParams, processSerchParam}}>
            {children}
        </SearchParamContext.Provider>
    );
}

export default SearchParamContext
